import React from "react";
import PropTypes from "prop-types";

import { H2 } from "components/core/Typography";
import Container from "components/core/Page/Container";
import ReviewListV2 from "./ReviewListV2";

import "./Reviews.scss";

const Reviews = ({ totalReviews, isGoogleReviewEnabled, googleReviews, ...rest }) => {
	const hasVerifiedReviews = totalReviews > 0;
	const hasGoogleReviews = isGoogleReviewEnabled && googleReviews?.user_ratings_total > 0;

	// Don't render the section if there are no reviews at all
	if (!hasVerifiedReviews && !hasGoogleReviews) {
		return null;
	}

	return (
		<div
			className="reviews-section-v2"
			id="reviews"
		>
			<Container>
				<H2 size="xxlarge">Customer Reviews</H2>
				<ReviewListV2
					totalReviews={totalReviews}
					isGoogleReviewEnabled={isGoogleReviewEnabled}
					googleReviews={googleReviews}
					{...rest}
				/>
			</Container>
		</div>
	);
};

Reviews.propTypes = {
	totalReviews: PropTypes.number,
	isGoogleReviewEnabled: PropTypes.bool,
	googleReviews: PropTypes.shape({
		rating: PropTypes.number,
		user_ratings_total: PropTypes.number,
		placeId: PropTypes.string,
		reviews: PropTypes.arrayOf(PropTypes.object)
	})
};

export default Reviews;
